<div *ngIf="showErrorBanner" class="row">
  <div class="alert alert-danger errors-div col-12">
    <span class="bold-text">{{ BOLDTEXT }}</span> {{ TEXT }}
  </div>
</div>
